
import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import useResponsive from "@/hooks/useResponsive";
import apiClient from "../utils/apiClient";

const Accounting = ({ leadId, bookingId }) => {
const { isMobile } = useResponsive();

    const [payments, setPayments] = useState([]);
    const [financialSummary, setFinancialSummary] = useState(null);

    useEffect(() => {
        if (!leadId) return;

        fetchPayments(); 

       fetchFinancialSummary();

    }, [leadId, bookingId]);


    const fetchPayments = async () => {
        try {
            const response = await apiClient.get(
                `/accounting/leads/${leadId}/payments`
            );

            setPayments(response.data?.data || []);
        } catch (error) {
            console.error(
                "Error fetching payments:",
                error
            );

            setPayments([]);
        }
    };

    const fetchFinancialSummary = async () => {
        try {
            const response = await apiClient.get(
                `/accounting/leads/${leadId}/financial-summary`
            );

            setFinancialSummary(
                response.data?.data || {}
            );
        } catch (error) {
            console.error(
                "Error fetching financial summary:",
                error
            );

            setFinancialSummary(null);
        }
    };


    return (
        <div>
            {/* PAGE TITLE */}

            <h2
                style={{
                    fontSize: 24,
                    fontWeight: 700,
                    marginBottom: 24,
                }}
            >
                Payments
            </h2>

            {/* SUMMARY CARDS */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fit,minmax(260px,1fr))",
                    gap: 20,
                    marginBottom: 28,
                }}
            >
                {/* TOTAL VALUE */}

                <div
                    style={{
                        background: "#fff",
                       overflowX:"auto", 
                       border: "1px solid #e5e7eb",
                        borderRadius: 18,
                        padding: 22,
                    }}
                >
                    <div
                        style={{
                            color: "#6b7280",
                            fontSize: 14,
                            marginBottom: 10,
                        }}
                    >
                        Total Value
                    </div>

                    <div
                        style={{
                            fontSize: 34,
                            fontWeight: 700,
                            color: "#111827",
                        }}
                    >
                        ₹
                        {(
                            financialSummary?.totalAmount ||
                            0
                        ).toLocaleString()}
                    </div>
                </div>

                {/* RECEIVED */}

                <div
                    style={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: 18,
                        padding: 22,
                    }}
                >
                    <div
                        style={{
                            color: "#6b7280",
                            fontSize: 14,
                            marginBottom: 10,
                        }}
                    >
                        Received
                    </div>

                    <div
                        style={{
                            fontSize: 34,
                            fontWeight: 700,
                            color: "#16a34a",
                        }}
                    >
                        ₹
                        {(
                            financialSummary?.totalReceived ||
                            0
                        ).toLocaleString()}
                    </div>
                </div>

                {/* BALANCE */}

                <div
                    style={{
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                        borderRadius: 18,
                        padding: 22,
                    }}
                >
                    <div
                        style={{
                            color: "#6b7280",
                            fontSize: 14,
                            marginBottom: 10,
                        }}
                    >
                        Balance
                    </div>

                    <div
                        style={{
                            fontSize: 34,
                            fontWeight: 700,
                            color: "#dc2626",
                        }}
                    >
                        ₹
                        {(
                            financialSummary?.totalPending ||
                            0
                        ).toLocaleString()}
                    </div>
                </div>
            </div>



            {/* PAYMENT HISTORY */}

<div
    style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 18,
        overflowX: "auto",
        overflowY: "hidden",
    }}
>

                {/* HEADER */}

                <div
                    style={{
                        padding: "20px 24px",
                        fontSize: 16,
                        fontWeight: 600,
                        borderBottom:
                            "1px solid #e5e7eb",
                    }}
                >
                    Payment History
                </div>

                {/* EMPTY */}

                {payments.length === 0 ? (
                    <div
                        style={{
                            padding: 50,
                            textAlign: "center",
                            color: "#9ca3af",
                        }}
                    >
                        No payments logged yet
                    </div>
                ) : (
                    payments.map(
                        (payment, index) => (
                            <div
                                key={payment._id}

style={{
    display: "grid",
    gridTemplateColumns: isMobile
        ? "1fr"
        : "220px 220px 220px 180px",
    alignItems:
        "center",
    padding:
        "22px 24px",
    columnGap: isMobile ? 12 : 50,
    rowGap: isMobile ? 10 : 0,
                                    borderBottom:
                                        "1px solid #f3f4f6",
                                }}
                            >
                                {/* INSTALLMENT */}

<div
    style={{
        fontSize: 14,
        fontWeight: 600,
        color: "#111827",
    }}
>
    Installment{" "}
    {
        payment.installmentNumber ||
        index + 1
    }
</div>


                                {/* AMOUNT */}

                                <div
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 700,
                                        color:
                                            "#111827",
                                    }}
                                >
                                    ₹
                                    {(
                                        payment.amount ||
                                        0
                                    ).toLocaleString()}
                                </div>

                                {/* DATE */}

                                <div
                                    style={{
                                        fontSize: 14,
                                        color:
                                            "#6b7280",
                                    }}
                                >
                                    {payment.createdAt
                                        ? new Date(
                                              payment.createdAt
                                          ).toLocaleDateString()
                                        : "-"}
                                </div>

                                {/* STATUS */}

                                <div>
                                    <span
                                        style={{
                                            display:
                                                "inline-flex",
                                            alignItems:
                                                "center",
                                            justifyContent:
                                                "center",
                                            padding:
                                                "7px 16px",
                                            borderRadius:
                                                "999px",
                                            fontSize: 12,
                                            fontWeight: 600,
                                            background:
                                                payment.verificationStatus ===
                                                "verified"
                                                    ? "#dcfce7"
                                                    : "#fef3c7",
                                            color:
                                                payment.verificationStatus ===
                                                "verified"
                                                    ? "#166534"
                                                    : "#92400e",
                                        }}
                                    >
                                        {payment.verificationStatus ===
                                        "verified"
                                            ? "Verified"
                                            : "Pending"}
                                    </span>
                                </div>
                            </div>
                        )
                    )
                )}
            </div>
        </div>
    );
};

export default Accounting;
